import styled from 'styled-components';

export const Wrapper = styled.div`
  width: fit-content;
  height: 20px;
  padding: 1px 6px;
  border-radius: 999px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: conic-gradient(
    from 79.29deg at 51.11% 55.56%,
    #26b75d -31.41deg,
    #25aa95 21.64deg,
    #4385f5 115.55deg,
    #ff0000 190.21deg,
    #faaf30 267.71deg,
    #26b75d 328.59deg,
    #25aa95 381.64deg
  );
`;
